import { createSlice } from "@reduxjs/toolkit"

const defaultState = {
    Batchprep: [],
    verify: [], 
    file: [],
    unmatched: [], 
    unmatchedHistory: [], 
    BatchPrepLoader : false,
    verifyLoader: false, 
    fileLoader: false, 
    unmatchedLoader: false, 
    titleIntakeCounts: {}, 
    titleIntakeAllTabsCount: {}, 
    isFileIdEdit: false
}


const titleIntakeReducer = createSlice(({
    name: 'titleIntake',
    initialState: defaultState,
    reducers: {
        setTitleIntakeLoader: (state, action) => {
            state = {
                ...state,
                [action.payload.type]: action?.payload?.loaderStatus,
            }

            return state
        },
        setTitleIntakeData: (state, action) => { 
            state = {
                ...state,
                [action.payload.type]: action?.payload?.data?.length > 0 ? action.payload.data : [],
                titleIntakeAllTabsCount : { 
                    ...state.titleIntakeAllTabsCount,
                    [action.payload.type] : action.payload.count  
                }
            }
            return state
        },
        updateTitleIntakeData: (state, action) => { 
            state = {
                ...state,
                [action.payload.type]: action.payload.data,
            }
            return state
        },
        setTitleIntakeCounts: (state, action) => {
            state = {
                ...state,
                titleIntakeCounts: action.payload,
            }
            return state
        },
        setIsFileIdEdit: (state, action) => {
            state = {
                ...state,
                isFileIdEdit: action.payload,
            }
            return state
        },

    }

}))

export const { setTitleIntakeData, setTitleIntakeLoader, updateTitleIntakeData, setTitleIntakeCounts ,setIsFileIdEdit} = titleIntakeReducer.actions

export default titleIntakeReducer.reducer; 